export default "__VITE_ASSET__jQmWB1Fi__"